@import '../../scss';

:host {

  phn-p-button-pure {
    position: relative;
    display: inline-block;
    vertical-align: top;
    outline: 0px !important;
  }

  .myporsche-unread-messages-indicator {
    position: absolute;
    width: p-px-to-rem(6px);
    height: p-px-to-rem(6px);
    border-radius: 50%;

    &.light{
      background-color: $pds-theme-light-notification-error;
    }

    &.dark{
      background-color: $pds-theme-light-notification-error;
    }
  }
}
